var _path, _rect, _rect2, _path2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHelpAndFaqIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 34,
    viewBox: "0 0 36 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M15 2H21C23.8423 2 25.9238 2.00075 27.5166 2.21484C28.9963 2.41378 29.9884 2.78993 30.7412 3.4707L30.8887 3.61133C31.659 4.38163 32.0729 5.40498 32.2852 6.9834C32.4993 8.57616 32.5 10.6577 32.5 13.5V19.5C32.5 22.3423 32.4993 24.4238 32.2852 26.0166C32.0862 27.4963 31.7101 28.4884 31.0293 29.2412L30.8887 29.3887C30.1184 30.159 29.0951 30.5729 27.5166 30.7852C25.9238 30.9993 23.8423 31 21 31H15C12.1577 31 10.0762 30.9993 8.4834 30.7852C7.00375 30.5862 6.01168 30.2101 5.25879 29.5293L5.11133 29.3887L4.9707 29.2412C4.28993 28.4884 3.91378 27.4963 3.71484 26.0166C3.50075 24.4238 3.5 22.3423 3.5 19.5V13.5C3.5 10.6577 3.50075 8.57616 3.71484 6.9834C3.91378 5.50374 4.28994 4.51168 4.9707 3.75879L5.11133 3.61133C5.88163 2.84103 6.90496 2.42706 8.4834 2.21484C10.0762 2.00075 12.1577 2 15 2Z",
    fill: "white",
    stroke: "#8A91A5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 7.5,
    width: 15,
    height: 18,
    rx: 1.5,
    stroke: "#A2ADCD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 6.5,
    width: 14,
    height: 17,
    rx: 1.5,
    fill: "white",
    stroke: "#394D8B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0465 12.9075C19.2564 13.1251 19.333 13.4307 19.297 13.7263C19.2447 14.1552 19.1209 14.5569 18.9756 14.9618C18.8202 15.3951 18.6624 15.8274 18.5039 16.2595C18.2503 16.951 17.9947 17.6416 17.7439 18.3341C17.6816 18.506 17.6372 18.6897 17.6194 18.8714C17.6001 19.0692 17.7424 19.1666 17.921 19.0788C18.0641 19.0084 18.2034 18.9127 18.3155 18.7994C18.4985 18.6143 18.6808 18.4283 18.8586 18.238C18.9475 18.1429 19.0354 18.0467 19.1217 17.9491C19.1904 17.8712 19.261 17.7542 19.3553 17.7068C19.5339 17.6172 19.6717 17.8377 19.6394 17.9921C19.6085 18.1398 19.5068 18.2693 19.4133 18.3872L19.4068 18.3953C19.3983 18.406 19.3899 18.4167 19.3815 18.4274C19.0671 18.8272 18.7224 19.2128 18.3313 19.5387C17.9468 19.8582 17.52 20.13 17.0512 20.3063C16.8985 20.3637 16.7421 20.4109 16.5831 20.447C16.2761 20.5169 15.9368 20.5117 15.6231 20.4661C15.393 20.4327 15.1862 20.286 15.0887 20.0725C14.9195 19.7018 15.0373 19.2441 15.1248 18.8668C15.232 18.4049 15.3929 17.9651 15.5573 17.5226L15.5698 17.489L15.5761 17.4722L15.5886 17.4386L15.6011 17.4049C15.7916 16.892 15.9874 16.3812 16.1839 15.8707C16.3632 15.4049 16.5432 14.9395 16.7207 14.473C16.7342 14.4374 16.7493 14.402 16.7646 14.3667L16.7703 14.3534C16.8095 14.2629 16.8484 14.1723 16.863 14.0779C16.898 13.8514 16.7346 13.6497 16.5079 13.7803C16.1159 14.006 15.8223 14.3417 15.5314 14.6795L15.496 14.7205C15.4056 14.8255 15.3151 14.9303 15.2216 15.0316C15.1294 15.1314 15.0196 15.2552 14.8612 15.1408C14.692 15.0187 14.7422 14.8622 14.8383 14.7295C15.3722 13.9929 16.0131 13.3038 16.8484 12.9146C17.1975 12.752 17.6856 12.5864 18.1426 12.581C18.4852 12.577 18.8104 12.6629 19.0465 12.9075ZM19.5738 9.58494C20.0132 9.75594 20.25 10.138 20.25 10.6759C20.25 11.6452 19.203 12.3082 18.3277 11.8931C17.8753 11.6785 17.6553 11.17 17.765 10.5925C17.9168 9.79275 18.8179 9.29085 19.5738 9.58494Z",
    fill: "#394D8B"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 9.5,
    width: 4,
    height: 3,
    rx: 1.5,
    fill: "#394D8B",
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 13.5,
    width: 4,
    height: 3,
    rx: 1.5,
    fill: "#394D8B",
    stroke: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 17.5,
    width: 4,
    height: 3,
    rx: 1.5,
    fill: "#394D8B",
    stroke: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpAndFaqIcon);
export default __webpack_public_path__ + "static/media/HelpAndFAQIcon.8119ce52d6bb71e1f42670fd286ef982.svg";
export { ForwardRef as ReactComponent };